import { Injectable } from '@angular/core';
import { ProcessImageEvent } from '../models/process-image-event.model';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { LiveValue } from '@core/services/live-value.service';

@Injectable()
export class ProcessImageService {
  public readonly processImageEvent$: Observable<ProcessImageEvent>;
  public readonly includeSignalEvent$: Observable<string[]>;
  public readonly dataStream$: Observable<LiveValue[]>;

  private readonly _processImageEvent$: Subject<ProcessImageEvent>;
  private readonly _includeSignalEvent$: Subject<string[]>;
  private readonly _dataStream$: BehaviorSubject<LiveValue[]>;

  constructor() {
    this._processImageEvent$ = new Subject();
    this._includeSignalEvent$ = new Subject();
    this._dataStream$ = new BehaviorSubject<LiveValue[]>([]);

    this.processImageEvent$ = this._processImageEvent$.asObservable();
    this.includeSignalEvent$ = this._includeSignalEvent$.asObservable();
    this.dataStream$ = this._dataStream$.asObservable();
  }

  public publishEvent(prcImgEvent: ProcessImageEvent): void {
    this._processImageEvent$.next(prcImgEvent);
  }
}
